// The selected head-tab "sheet" blends into the panel below it. The light gradient
// (#ECF0F3 -> #FFFFFF) is tuned for the light panel; in dark mode it stayed a bright
// sheet with light text on top -> invisible (DEV-4566). Flip to the dark paper
// surface so the selected tab reads against the dark panel.
const getSelectedTabBackground = ({ palette }) =>
  palette.mode === 'dark'
    ? palette.background.paper
    : 'linear-gradient(180deg, #ECF0F3 0%, #FFFFFF 100%)';

export const wrapperStyles = {
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
  gap: '20px',
};

export const tabsStyles = {
  minHeight: 'unset',
  flex: 1,
  gap: '7px',
  borderRadius: '8px 8px 0 0',

  '& .MuiTabs-scroller': {
    scrollBehavior: 'smooth',
  },
};

export const getTabStyles = customStyles => ({
  position: 'relative',
  maxWidth: '180px',
  minHeight: 'unset',
  height: '40px',
  padding: '0 16px',
  color: ({ palette }) => palette.text.secondary,
  textTransform: 'none',
  borderRadius: '8px 8px 0 0',
  borderTop: ({ palette }) => `1px solid ${palette.background.primary}`,
  backgroundColor: ({ palette }) => palette.background.hoverDefault,
  overflow: 'visible',

  '&:nth-of-type(1)': {
    '&:after': {
      display: 'none',
    },
  },

  '&:after, &:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '8px',
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
  },

  '&:before': {
    right: '-8px',
    clipPath: 'polygon(0 8px, 0 100%, 100% 100%)',
  },

  '&:after': {
    left: '-8px',
    clipPath: 'polygon(8px 8px, 0 100%, 100% 100%)',
  },

  '&[aria-selected="true"]': {
    color: ({ palette }) => palette.text.primary,
    background: getSelectedTabBackground,
    zIndex: 1,

    '&:before, &:after': {
      background: getSelectedTabBackground,
    },
  },

  ...customStyles,
});

export const labelWrapperStyles = {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  gap: '4px',
};

export const pendingChangesCounterStyles = {
  flexShrink: 0,
  marginRight: '10px',

  '& .pending-changes-count': {
    fontWeight: 400,
  },
};

export const labelStyles = {
  position: 'relative',
  width: '100%',
  fontSize: '1.6rem',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const additionalAfterStyles = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  width: '8px',
  right: '-8px',
  backgroundColor: ({ palette }) => palette.background.paper,
  clipPath: 'polygon(0 8px, 0.5px 8px, 8.5px 100%, 8px 100%)',
  zIndex: 1,
};
